<template>
  <modal
    :show.sync="editModal"
    scrollable
    :hide-footer="true"
    header-classes="bg-primary p-2 flex items-center"
    size="lg"
    @close="closeModal"
  >
    <h6 slot="header" class="modal-title text-white pl-4 font-semibold">
      Edit
    </h6>
    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(saveChanges)">
        <div>
          <div class="mb-4 flex w-full">
            <div class="w-1/2 pr-2">
              <label class="col-form-label form-control-label pt-0"
                >Course Icon</label
              >

              <b-form>
                <b-form-file
                  v-model="icone"
                  @change="filesChange"
                  placeholder="Select file"
                  drop-placeholder="Drop file here..."
                  accept=".jpg,.png"
                ></b-form-file>
                <span v-if="imageErr" class="small text-danger">{{
                  msg.image
                }}</span>
              </b-form>
              <div class="">
                <label class="col-form-label form-control-label"
                  >Course Name</label
                >

                <base-input
                  v-model="editCourse.name"
                  placeholder="Enter Course Name"
                  class="cust-mb0"
                  name="Name"
                  :rules="{ required: true }"
                ></base-input>
              </div>
            </div>
            <div class="ml-2 border w-1/2 h-152px rounded-md bg-ededed">
              <!-- <h1 class="h-full items-center flex justify-center">
              Image Preview
            </h1> -->
              <img
                :src="$imageURL + '/' + selectedCourse.icone"
                class="object-contain w-full h-full rounded-md"
              />
            </div>
          </div>

          <div class="mb-4 flex w-full">
            <div class="w-1/2">
              <!-- <div class="mb-4">
            <b-input
              placeholder="Type a question"
              v-model="text"
              :value="text"
              class="form-control-muted"
            />
          </div> -->
              <div class="">
                <label class="col-form-label form-control-label"
                  >Author Name</label
                >
                <div class="flex justify-between">
                  <!-- <select class="form-control mr-4">
                  <option v-for="option in author" :key="option">
                    {{ option.name }}
                  </option>
                </select> -->
                  <!-- <v-select multiple :options="author.name"> -->
                  <!-- <template slot="selection" scope="data">
                  {{ data.item.name }}
                </template> -->
                  <!-- <option v-for="option in author" :key="option">
                  {{ option.name }}

                </option> -->
                  <!-- </v-select> -->
                  <div class="mr-4 w-full">
                    <base-input
                      class=""
                      :rules="{ required: true }"
                      v-model="selectedAuthor"
                      name="Author"
                    >
                      <multiselect
                        v-model="selectedAuthor"
                        :options="options"
                        :searchable="false"
                        label="name"
                        track-by="name"
                        :multiple="true"
                        :close-on-select="true"
                        placeholder="Select Author"
                        openDirection="bottom"
                        @input="selectAuth"
                      >
                      </multiselect>
                    </base-input>
                  </div>
                  <!-- <div>
                  <base-button
                    size="base"
                    type="primary"
                    @click="DeleteAnswer(index)"
                    >Delete</base-button
                  >
                </div> -->
                </div>
              </div>
            </div>
            <div class="w-1/2 pl-4">
              <label class="col-form-label form-control-label"
                >Course Categories</label
              >
              <base-input
                class=""
                :rules="{ required: true }"
                v-model="selectedCat"
                name="Categories"
              >
                <select
                  v-model="selectedCat"
                  class="form-control"
                  @change="selectCat"
                >
                  <option
                    v-for="option in categories"
                    :key="option._id"
                    :value="option._id"
                  >
                    {{ option.name }}
                  </option>
                </select>
              </base-input>
            </div>
          </div>
          <!-- <div class="mb-4 flex items-center">
          <div class="w-1/2 pr-2">
            <label class=" col-form-label form-control-label"
              >Author Name</label
            >
            <base-input placeholder="Enter Author Name"></base-input>
          </div>

          <div class="w-1/2 pl-2 pt-4">
            <p class="font-semibold text-sm mb-2">Course Language</p>
            <base-input class="">
              <select class="form-control ">
                <option> Select </option>
                <option> English </option>

                <option> Hindi </option>
                <option> Marathi </option>
                <option> Tamil </option>
                <option> Spanish </option>
              </select>
            </base-input>
          </div>
        </div> -->
          <!-- 
        <div class="mb-4 ">
          <div class="w-1/2">
            <label class=" col-form-label form-control-label"
              >About the course</label
            >

            <textarea
              class="form-control"
              placeholder="Enter details about the course"
              id="exampleFormControlTextarea3"
              rows="3"
            ></textarea>
          </div>
        </div> -->

          <div class="mb-4 flex w-full">
            <div class="w-full">
              <label class="col-form-label form-control-label"
                >About the course</label
              >
              <base-input
                class=""
                :rules="{ required: true }"
                v-model="editCourse.coursefor"
                name="About"
              >
                <textarea
                  v-model="editCourse.coursefor"
                  class="form-control w-full"
                  placeholder="Enter details about the course"
                  id="exampleFormControlTextarea3"
                  rows="3"
                ></textarea>
              </base-input>
            </div>

            <!-- <div class="w-1/2 pl-2">
            <label class="col-form-label form-control-label"
              >Upload Image (About the course)</label
            >

            <b-form>
              <b-form-file
                v-model="aboutImg"
                @change="filesChange"
                placeholder="Select file"
                drop-placeholder="Drop file here..."
              ></b-form-file>
            </b-form>
          </div> -->
          </div>

          <div class="mb-4 flex w-full">
            <div class="w-1/2 pr-2">
              <label class="col-form-label form-control-label"
                >Course Content</label
              >

              <!-- <textarea
              v-model="content"
              class="form-control"
              placeholder="Enter Course Content"
              id="exampleFormControlTextarea3"
              rows="3"
            ></textarea> -->
              <!-- <TextEditor /> -->
              <div class="">
                <base-input
                  class=""
                  :rules="{ required: true }"
                  v-model="editCourse.content"
                  name="Content"
                >
                  <quill-editor
                    v-model="editCourse.content"
                    :options="editorOption"
                    class="quill-h300px"
                  />
                </base-input>
              </div>
            </div>
            <div class="w-1/2 pl-2">
              <div class="w-full">
                <label class="col-form-label form-control-label"
                  >Total Hours
                </label>

                <base-input
                  v-model="editCourse.duration"
                  placeholder="Enter Total Hours"
                  name="hours"
                  class="mb-0"
                  :rules="{ numeric: true, required: true }"
                ></base-input>
              </div>
              <label class="col-form-label form-control-label"
                >Course Description</label
              >
              <base-input
                class=""
                :rules="{ required: true }"
                v-model="editCourse.description"
                name="Description"
              >
                <textarea
                  v-model="editCourse.description"
                  class="form-control"
                  placeholder="Enter Who this course is for"
                  id="exampleFormControlTextarea3"
                  rows="3"
                ></textarea>
              </base-input>
            </div>
          </div>
          <!-- <div class="mb-4 flex w-full">
        <div class="w-1/2 pr-2">
          
        </div> -->
          <!-- <div class="w-1/2 pl-2">
            <label class="col-form-label form-control-label"
              >Upload Image (Who this course is for)</label
            >
            <b-form>
              <b-form-file
                v-model="courseForImg"
                @change="filesChange"
                placeholder="Select file"
                drop-placeholder="Drop file here..."
              ></b-form-file>
            </b-form>
          </div> -->
          <!-- </div> -->
          <div>
            <label class="col-form-label form-control-label">Certificate</label
            ><br />

            <input type="radio" value="false" v-model="appr" id="On Approval" />
            <label for="On Approval" class="pl-2"> On Approval</label><br />

            <input
              type="radio"
              value="true"
              v-model="appr"
              id="On complision"
            />
            <label for="On complision" class="pl-2">On Completion</label><br />
          </div>
          <div class="w-full flex">
            <div class="w-1/2 pr-2">
              <label class="col-form-label form-control-label"
                >Course Reader Level</label
              >
              <base-input
                class=""
                :rules="{ required: true }"
                v-model="editCourse.level"
                name="Reader Level"
              >
                <select v-model="editCourse.level" class="form-control">
                  <option>Beginners</option>
                  <option>Medium</option>
                  <option>High</option>
                </select>
              </base-input>
            </div>
            <div class="w-1/2 pl-2">
              <label class="col-form-label form-control-label"
                >Course Language</label
              >
              <base-input
                class=""
                :rules="{ required: true }"
                v-model="editCourse.language"
                name="Language"
              >
                <select v-model="editCourse.language" class="form-control">
                  <option>Select</option>
                  <option>English</option>

                  <option>Hindi</option>
                  <option>Marathi</option>
                  <option>Tamil</option>
                  <option>Spanish</option>
                </select>
              </base-input>
            </div>
            <div class="w-1/2 pl-4">
              <label class="col-form-label form-control-label"
                >Course Type</label
              >

              <base-input
                class=""
                :rules="{ required: true }"
                v-model="editCourse.courseType"
                name="Type"
              >
                <select v-model="editCourse.courseType" class="form-control">
                  <option>Free</option>
                  <option>Paid</option>
                </select>
              </base-input>
            </div>
          </div>

          <div class="flex items-center">
            <!-- <div class="w-1/2 pr-2 ">
            <label class=" col-form-label form-control-label"
              >Course Categories</label
            >
            <base-input class="">
              <select v-model="selectedCat" class="form-control">
                <option
                  v-for="option in categories"
                  :key="option"
                  :value="option"
                >
                  {{ option.name }}
                </option>
              </select>
            </base-input>
          </div> -->

            <!-- <div class="w-1/2 pl-2">
            <label class=" col-form-label form-control-label"
              >Total Hours
            </label>

            <base-input
              v-model="duration"
              placeholder="Enter Total Hours"
              class="mb-0"
            ></base-input>
          </div> -->
          </div>
          <div
            class="flex items-center"
            v-if="editCourse.courseType === 'Paid'"
          >
            <div class="w-1/2 pr-2">
              <label class="col-form-label form-control-label"
                >Actual Rate (In INR)</label
              >

              <base-input
                v-model="editCourse.price"
                :rules="{ numeric: true }"
                placeholder="Enter Actual Rate"
                name="price"
                class="mb-0"
              ></base-input>
            </div>
            <div class="w-1/2 pr-2">
              <label class="col-form-label form-control-label"
                >Discount (in %)</label
              >

              <base-input
                v-model="discount"
                placeholder="Enter Discounted Rate"
                :rules="{ numeric: true }"
                name="discount"
                class="mb-0"
              ></base-input>
            </div>
            <div class="w-1/2 pr-2">
              <label class="col-form-label form-control-label"
                >Discounted Rate (in INR)</label
              >

              <base-input
                v-model="discountPrice"
                placeholder="Enter Discounted Rate"
                class="mb-0"
                readonly
              ></base-input>
            </div>
          </div>
          <div class="flex items-center">
            <div class="w-1/2 pr-2">
              <label class="col-form-label form-control-label"
                >Choose Platform</label
              >
              <base-input
                class=""
                :rules="{ required: true }"
                v-model="platform"
                name="Platform"
              >
                <multiselect
                  v-model="platform"
                  :options="platformOptions"
                  :searchable="false"
                  :multiple="true"
                  :close-on-select="true"
                  placeholder="Select platform"
                  openDirection="bottom"
                  @input="selectPlatform"
                >
                </multiselect>
              </base-input>
            </div>
          </div>
        </div>

        <div class="modal-footer p-0">
          <base-button native-type="submit" type="primary"
            >SAVE CHANGES</base-button
          >
          <base-button
            @click="editModal = false"
            type="secondary"
            class="ml-auto"
            >CLOSE</base-button
          >
        </div>
      </b-form>
    </validation-observer>
    <template slot="footer" class="p-0"><div class="p-0"></div> </template>
  </modal>
</template>

<script>
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
export default {
  components: {
    Multiselect,
    quillEditor,
  },

  data() {
    return {
      // name: "",
      // description: "",
      // content: "",
      // courseFor: "",
      // duration: "",
      // price: "",
      // discountPrice: "",
      editorOption: {
        modules: {
          toolbar: [
            [
              "bold",
              "italic",
              "underline",
              "strike",
              "link",
              "blockquote",
              "code-block",
            ],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ font: [] }],
          ],
        },
        placeholder: "Message",
      },
      icone: "",
      courseForImg: "",
      aboutImg: "",
      contentImg: "",
      platform: "",
      // language: "",
      // level: "",
      // discount: "",
      platformOptions: ["TV", "Mobile", "Desktop", "tabs"],
      selectedAuthorId: [],
      selectedAuthor: [],
      selectedCat: "",
      selected: [],
      selectedPlatform: [],
      options: [],
      discount: "",
      editCourse: {},
      appr: false,
      imageErr: false,
      msg: {
        image: "",
      },
    };
  },
  props: {
    editModal: Boolean,
    selectedCourse: Object,
  },
  watch: {
    selectedCourse(val) {
      if (val) {
        this.editCourse = { ...val };
      }
    },
    editModal(val) {
      if (val) {
        this.selectedAuthor = this.editCourse.author.map((items) => ({
          name: items.userId
            ? items.userId.firstname
              ? items.userId.firstname
              : "" + " " + items.userId.lastname
              ? items.userId.lastname
              : ""
            : "",
          // lastname : items.userId.lastname,
          _id: items._id,
        }));
        this.selectedCat = this.editCourse.category[0]._id;
        this.platform = this.editCourse.platform;
        this.selectedPlatform = this.editCourse.platform;
        this.appr = this.editCourse.appr;
        this.discount =
          this.editCourse.price && this.editCourse.discountPrice
            ? ((this.editCourse.price - this.editCourse.discountPrice) /
                this.editCourse.price) *
              100
            : 0;
        // console.log(this.discount);
      }
    },
  },
  methods: {
    filesChange(event) {
      // console.log(event.target.files[0].type);
      // this.imageErr = false;
      // if (event.target.files[0].type.includes("video")) {
      //   this.imageErr = true;
      //   this.msg.image = "Upload Image Only";
      // } else {
      //   this.imageErr = false;
      //   this.icone = event.target.files[0];
      // }
      let mByte = 5 * 1048576;
      if (event.target.files[0].size > mByte) {
        this.icone = null;
        event = {};
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          // text: "Please ensure that the file size does not exceed 5MB",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        this.imageErr = true;
        this.msg.image = "File size exceeds the allowed limit!";
        // return;
      } else {
        this.imageErr = false;
        if (!event.target.files[0].type.includes("image")) {
          this.icone = null;
          event = {};
          this.imageErr = true;
          this.msg.image = "Upload Image Only";
        } else {
          this.imageErr = false;
          this.icone = event.target.files[0];
        }
      }
    },
    selectAuth(selectedAuthor) {
      // alert(selectedAuthor._id);
      // this.selected.push(selectedAuthor._id);
      this.selected = selectedAuthor;
      // console.log(this.selected);
      // console.log(selectedAuthor);
      // alert(this.selected);
    },
    // removeAuth(selectedAuthor, id) {
    //   const index = this.selected.findIndex((x) => x == selectedAuthor._id);
    //   this.selected.splice(index, 1);
    // },
    selectCat(selectedCat) {
      // console.log(selectedCat);
      // alert(selectedCat);
    },
    selectPlatform(platform) {
      // this.selectedPlatform.push(platform);
      this.selectedPlatform = this.platform;
      // console.log(this.platform);
      // console.log(this.selectedPlatform);
    },
    async saveChanges() {
      if (this.editCourse.name.length != 0) {
        let loader = this.$loading();
        let payload = new FormData();
        payload.append("appr", this.appr);
        payload.append("name", this.editCourse.name);
        payload.append("description", this.editCourse.description);
        payload.append("content", this.editCourse.content);
        payload.append("coursefor", this.editCourse.coursefor);
        payload.append("duration", this.editCourse.duration);
        payload.append("price", this.editCourse.price);
        payload.append("courseType", this.editCourse.courseType);
        payload.append("discountPercent", this.discount);
        if (this.discountPrice == "" || this.discountPrice == 0) {
          payload.append("discountPrice", this.editCourse.price);
        } else {
          payload.append("discountPrice", this.discountPrice);
        }
        payload.append("icone", this.icone);
        // payload.append("courseForImg", this.selectedCourse.courseForImg);
        // payload.append("aboutImg", this.selectedCourse.aboutImg);
        // payload.append("contentImg", this.selectedCourse.contentImg);
        payload.append("language", this.editCourse.language);
        this.selectedPlatform.map((data) => {
          payload.append("platform", data);
        });
        // payload.append("platform", this.selectedCourse.platform);
        payload.append("level", this.editCourse.level);
        // payload.append("author", this.selectedAuthor._id);
        this.selected.map((item) => {
          payload.append("author", item._id);
        });
        payload.append("category", this.selectedCat);
        payload.append("_id", this.editCourse._id);
        const data = await this.$store.dispatch(
          "eLearning/editCourse",
          payload
        );
        if (data.code == 200) {
          loader.close();
          this.$swal.fire({
            title: "Edited",

            text: "Course has been Edited Successfully!",

            icon: "success",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          this.closeModal();
        }
      } else {
        alert("Please Give Category");
      }
    },
    closeModal() {
      this.$emit("close-modal");
    },
    async getAuthorDetails() {
      const { data } = await this.$store.dispatch("author/getAuthors");
      // console.log(data);
      // console.log(this.authors);
      // console.log(this.selectedCourse.category.name);
      // console.log(this.categories);
      data[0].result.map((items) => {
        if (items.adminapproval === true) {
          const array = this.options.push({
            name: items.userId[0]
              ? items.userId[0].firstname
                ? items.userId[0].firstname
                : "" + " " + items.userId[0].lastname
                ? items.userId[0].lastname
                : ""
              : "",
            // lastname : items.userId.lastname,
            _id: items._id,
          });
        }
      });
    },
  },
  mounted() {
    this.getAuthorDetails();
  },
  computed: {
    ...mapState("eLearning", ["categories"]),

    discountPrice() {
      // console.log(this.editCourse.price, this.discount);
      return this.editCourse.price && this.discount
        ? this.editCourse.price - (this.editCourse.price / 100) * this.discount
        : 0;
    },
  },
};
</script>

<style>
.h-152px {
  height: 165px;
}
.quill-h300px > .ql-container {
  height: 200px;
}
</style>
